import { render } from "./checkTypePopupComponent.vue?vue&type=template&id=9ca9206e&scoped=true&ts=true"
import script from "./checkTypePopupComponent.vue?vue&type=script&lang=ts"
export * from "./checkTypePopupComponent.vue?vue&type=script&lang=ts"

import "./checkTypePopupComponent.vue?vue&type=style&index=0&id=9ca9206e&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca9206e"]])

export default __exports__